import React from 'react';

export default function EmptyState() {
  return (
    <div
      style={{
        margin: 'auto',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <div>
        <img src="/assets/empty-state/empty-folder.png" alt="" style={{ height: '150px' }} />
        <p style={{ textAlign: 'center', fontWeight: '700', fontSize: '20px' }}>
          Data not available
        </p>
      </div>
    </div>
  );
}
